import { useMemo, useContext } from 'react';
import { StylesContext, createTokenFn } from '@rexlabs/element-styles';
export default function useToken() {
  var _useContext = useContext(StylesContext),
      tokens = _useContext.tokens;

  return useMemo(function () {
    return createTokenFn(tokens || {});
  }, [tokens]);
}